import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { CellClassRules, ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-enterprise';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { ReportService } from '../..';
import { ConstantService } from '@app/_services/constant.service';
import 'ag-grid-enterprise';

@Component({
    selector: 'app-biz-dev-property-development',
    templateUrl: './biz-dev-property-development.component.html',
    styleUrls: ['./biz-dev-property-development.component.css'],
    standalone: false
})
export class BizDevPropertyDevelopmentComponent implements OnInit {

	@Input() propertyDevelopments: any = [];

	constructor(
		public messageService: MessageService,
		public reportService: ReportService,
		private constantService: ConstantService,) { }

	gridApi: GridApi;
	columnApi: ColumnApi;

	// ag-grid columns
	occupancyNtsCellClassRule: CellClassRules = this.reportService.occupancyNtsCellClassRule;
	occupancyPctCellClassRule: CellClassRules = this.reportService.occupancyPctCellClassRule;


	autoGroupColumnDef = {
		headerName: 'Developments',
		cellRendererParams: {
			// suppressCount: true,
			// checkbox: true,
		}
	};

	defaultColDef: ColDef = {
		sortable: true,
		filter: true,
	};

	columnDefs: ColDef[] = [
		//Groups
		{ headerName: 'Location', field: 'locationId', rowGroup: true, hide: true,
		 cellRenderer: params => this.getLocationName(params) },
		{ headerName: 'Development', field: 'developmentName', rowGroup: true, hide: true},
    { headerName: 'Property', field: 'propertyCode', rowGroup: true, hide: true},

	];



	gridOptions: GridOptions = {
		rowData: this.propertyDevelopments,
		columnDefs: this.columnDefs,
		pagination: true,
		rowSelection: 'single',
		suppressAggFuncInHeader: true,

		// EVENTS
		// Add event handlers
		onRowClicked: event => console.log('A row was clicked'),
		onColumnResized: event => console.log('A column was resized'),
		onGridReady: event => console.log('The grid is now ready'),

		// CALLBACKS
		getRowHeight: (params) => 25,

		aggFuncs: {
			// this overrides the grids built-in avg function
			'showArrivalDate': params => {
				console.log(JSON.stringify(params.values));
				if (params.values[1]) {
					return params.values[1].checkInDate;
				}
			},
		}
	}


	// forms
	formLoading = false;


	// to hold the current search
	currentSearchForm: any;


	// search defaults
	defaultStartDate: Date
	defaultEndDate: Date
	defaultReservationStatuses: any;
	defaultShortTermRentalIds: any;


	ngOnInit(): void {
		this.defaultStartDate = new Date();
		// this.defaultStartDate = new Date(this.defaultStartDate.getFullYear()-4, this.defaultStartDate.getMonth(), 1);
		this.defaultStartDate = new Date(this.defaultStartDate.getFullYear(), 0, 1); // jan 1
		this.defaultEndDate = new Date();
		this.defaultEndDate = new Date(this.defaultEndDate.getFullYear(), 12, 0);

		// ag-grid
		this.gridOptions.rowData = this.propertyDevelopments;
		this.gridOptions.columnDefs = this.columnDefs;
		this.gridOptions.autoGroupColumnDef = this.autoGroupColumnDef;
		this.gridOptions.pagination = true;
		this.gridOptions.suppressAggFuncInHeader = true;
		this.gridOptions.animateRows = true;
		this.gridOptions.defaultColDef = this.defaultColDef;

		// Footer
		this.gridOptions.groupIncludeFooter = true;
		this.gridOptions.groupIncludeTotalFooter = true;

		// https://www.ag-grid.com/javascript-data-grid/column-sizing/
		// this.gridOptions.suppressColumnVirtualisation = true;
	}

	ngAfterViewInit(): void {
		(this.gridOptions as any).api?.setColumnDefs(this.columnDefs);
	}
	
	getLocationName (params: any) {
		if (params.value) {
			return this.constantService.locations.find(function(item) { 
				return item.locationId == params.value 
			})?.name;
		}
	};

	onGridReady(grid: any): void {
		this.gridApi = grid;
		this.columnApi = grid.columnApi;

	}

	onRowGroupOpened(event) {
		this.columnApi.autoSizeAllColumns();
	}
	
	onFirstDataRendered(params: any): void {
		setTimeout(() => { this.columnApi.autoSizeAllColumns(); }, 5000);
	}

}
